import script from "./ProjectExportDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectExportDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProjectExportDialog.vue?vue&type=style&index=0&id=16200a7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16200a7c"]])

export default __exports__